import BaseService from "../BaseService";
import { API_BASE_URL_ENV } from "../../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sick-leaves";

export default class SickService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
